import styled from 'styled-components'

import { Flex, Icon, MenuEntry } from '@procsea/design-system'

export const StyledMenuEntry = styled(MenuEntry)`
  align-items: stretch;
  padding-left: 0;
  padding-right: ${props => props.theme.spacings.small};
`

export const StyledFlex = styled(Flex)`
  align-items: stretch;
`

export const StyledAnchor = styled.a<{ strech?: boolean }>`
  ${props => props.strech && 'flex: auto 1 1;'}
  display: flex;
  align-items: center;
  border-radius: ${props => props.theme.dimensions.borderRadius};
  padding-left: ${props => props.theme.spacings.small};
  &:hover {
    background-color: ${props => props.theme.menu.colors.secondary.lightest};
  }
`

export const StyledIcon = styled(Icon)`
  padding-right: ${props => props.theme.spacings.small};
`
